import CountUp from "react-countup";
import { Label, List, ListInlineItem } from "reactstrap";
import { Href } from "../../../../Constant";
import { COMMON_USER_DATA } from "../../../../Data/Users";
import { CommonUserFooterType } from "../../../../Type/UserType";


const CommonUserFooter = ({listClass}:CommonUserFooterType) => {
  return (
    <div className={`"like-comment ${listClass ? listClass : ""}`}>
      <List type="inline" className="justify-content-start mt-2">
        {COMMON_USER_DATA.map((item, index) => (
          <ListInlineItem className={item.listClass} key={index}>
            <Label className="m-0">
              <a href={Href}>
                <i className={`fa fa-${item.icon}`}></i>
              </a>
              {item.text}
            </Label>
            <CountUp end={item.count} className="ms-2" />
          </ListInlineItem>
        ))}
      </List>
    </div>
  );
};

export default CommonUserFooter;
